import LxcError from "~/core/models/LxcError.class";
import pkiService from "~/modules/pki/services/pki.service";

export function useDeletePki() {
  const isLoading: Ref<boolean | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function deletePki(alias: string): Promise<void> {
    isLoading.value = true;
    error.value = undefined;
    const response = await pkiService.deletePki(alias);

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    deletePki,
  };
}
